var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "expired-lot-inventory-page-wrapper" },
    [
      !_vm.hasFailedRequests
        ? _c(
            "list-page",
            {
              attrs: {
                "page-model": _vm.pageModel,
                "title-text": _vm.$t("expirationTrackedInventories.list.title"),
                "back-route": "/available-inventories"
              },
              scopedSlots: _vm._u([
                {
                  key: "search",
                  fn: function(ref) {
                    var filter = ref.filter
                    var filters = ref.filters
                    return [
                      _c("keyword-filter", {
                        attrs: {
                          id: "filter-name",
                          column: filters.searchQuery,
                          value: filters.searchQuery.filter.value
                        },
                        on: { filter: filter }
                      })
                    ]
                  }
                },
                {
                  key: "filters",
                  fn: function(ref) {
                    var filter = ref.filter
                    var filters = ref.filters
                    return [
                      _vm.$mq !== "mobile"
                        ? _c("flex-row", [
                            _c(
                              "div",
                              { staticClass: "col col--no-grow" },
                              [
                                _c(
                                  "select-filter",
                                  {
                                    attrs: {
                                      id:
                                        "expired-inventory-filter-inventoryTypes",
                                      name: filters.inventoryTypes.name,
                                      column: filters.inventoryTypes,
                                      searchable: false,
                                      "option-label": "label",
                                      "value-field": "value",
                                      "track-by": "value",
                                      disabled: _vm.failedWarehouse
                                    },
                                    on: { filter: filter }
                                  },
                                  [
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(filters.inventoryTypes) +
                                          "\n                        "
                                      )
                                    ]
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col col--no-grow" },
                              [
                                _c("select-filter", {
                                  attrs: {
                                    id: "expired-inventory-filter-warhouse",
                                    name: filters.warehouse.name,
                                    column: filters.warehouse,
                                    searchable: false,
                                    "option-label": "label",
                                    "value-field": "value",
                                    "track-by": "value",
                                    disabled: _vm.failedWarehouse
                                  },
                                  on: { filter: filter },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "singleLabel",
                                        fn: function(ref) {
                                          var option = ref.option
                                          return [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(filters.warehouse.name) +
                                                ": " +
                                                _vm._s(option.label) +
                                                "\n                        "
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    true
                                  )
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col col--no-grow" },
                              [
                                _c(
                                  "select-filter",
                                  {
                                    attrs: {
                                      id: "expired-inventory-filter-lotnumber",
                                      name: filters.lotNumber.name,
                                      column: filters.lotNumber,
                                      searchable: false,
                                      "option-label": "label",
                                      "value-field": "value",
                                      "track-by": "value"
                                    },
                                    on: { filter: filter }
                                  },
                                  [
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(filters.lotnumber) +
                                          "\n                        "
                                      )
                                    ]
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col col--no-grow" },
                              [
                                _c(
                                  "select-filter",
                                  {
                                    attrs: {
                                      id:
                                        "expired-inventory-filter-unavailableDate",
                                      name: "filters.unavailableDate.name",
                                      column: filters.unavailableDate,
                                      searchable: false,
                                      "option-label": "label",
                                      "value-field": "value",
                                      "track-by": "value"
                                    },
                                    on: { filter: filter }
                                  },
                                  [
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(filters.unavailableDate) +
                                          "\n                        "
                                      )
                                    ]
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col col--no-grow" },
                              [
                                _c(
                                  "select-filter",
                                  {
                                    attrs: {
                                      id:
                                        "expired-inventory-filter-expirationDate",
                                      name: "filters.expirationDate.name",
                                      column: filters.expirationDates,
                                      searchable: false,
                                      "option-label": "label",
                                      "value-field": "value",
                                      "track-by": "value"
                                    },
                                    on: { filter: filter }
                                  },
                                  [
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(filters.expirationDate) +
                                          "\n                        "
                                      )
                                    ]
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col col--width-date-range" },
                              [
                                _c("date-picker", {
                                  attrs: {
                                    id: "expired-inventory-filter-expiryDate",
                                    value: filters.expirationDate.filter.value,
                                    placeholder: _vm.$t(
                                      "expirationTrackedInventories.labels.expirationDate"
                                    ),
                                    "min-date":
                                      filters.expirationDate.filter.min,
                                    "max-date":
                                      filters.expirationDate.filter.max,
                                    mode: "range",
                                    "filter-style": ""
                                  },
                                  on: {
                                    "update:value": function($event) {
                                      return _vm.$set(
                                        filters.expirationDate.filter,
                                        "value",
                                        $event
                                      )
                                    },
                                    change: _vm.filterByDate
                                  }
                                })
                              ],
                              1
                            ),
                            _vm.isCreateBussinessOrderAllow
                              ? _c(
                                  "div",
                                  { staticClass: "col col--on-right" },
                                  [
                                    _c(
                                      "base-button",
                                      {
                                        staticClass: "button--no-uppercase",
                                        attrs: { primary: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.createExpiryItemsBusinessOrder()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$t(
                                                "expirationTrackedInventories.labels.createBusinessOrder"
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "notification",
                  fn: function() {
                    return [
                      _vm.expiredItemCount
                        ? _c(
                            "base-notification",
                            { attrs: { error: "", small: "", bright: "" } },
                            [
                              _c("p", { staticClass: "notification__title" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "expirationTrackedInventories.list.approachingExpirationWarning",
                                        { count: _vm.expiredItemCount }
                                      )
                                    ) +
                                    "\n                "
                                )
                              ]),
                              _vm.expiredItemCount
                                ? _c("p", [
                                    _c(
                                      "strong",
                                      [
                                        _vm.$hasAccess("items:read")
                                          ? _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "underline-text-only",
                                                attrs: {
                                                  to: {
                                                    name:
                                                      "inventory-approaching-expiration-window",
                                                    params: {
                                                      backLink:
                                                        "expiration-tracked-inventories"
                                                    },
                                                    query: { dateRange: 30 }
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  directives: [
                                                    {
                                                      name: "t",
                                                      rawName: "v-t",
                                                      value:
                                                        "expirationTrackedInventories.list.manageExpiredInventory",
                                                      expression:
                                                        "'expirationTrackedInventories.list.manageExpiredInventory'"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "underline-text-only__text"
                                                }),
                                                _c(
                                                  "svg",
                                                  {
                                                    staticClass:
                                                      "underline-text-only__icon",
                                                    attrs: {
                                                      width: "15",
                                                      height: "15"
                                                    }
                                                  },
                                                  [
                                                    _c("use", {
                                                      attrs: {
                                                        "xlink:href": "#link"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c(
                "div",
                {
                  staticClass: "title-action-buttons",
                  attrs: { slot: "titleAction" },
                  slot: "titleAction"
                },
                [
                  _c("title-button-tooltip", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.bottom",
                        value: {
                          content: _vm.$t(
                            "expirationTrackedInventories.disclaimer"
                          ),
                          delay: { show: 500, hide: 300 }
                        },
                        expression:
                          "{\n                    content: $t('expirationTrackedInventories.disclaimer'),\n                    delay: { show: 500, hide: 300 },\n                }",
                        modifiers: { bottom: true }
                      }
                    ]
                  })
                ],
                1
              ),
              _vm.$mq !== "mobile" || !_vm.pageModel.hasMobileView
                ? _c(
                    "base-table",
                    {
                      attrs: {
                        "fixed-header": "",
                        "invert-colors": "",
                        "offset-sides": "lg",
                        "row-uniq-id": _vm.pageModel.uniqueField,
                        columns: _vm.pageModel.columns,
                        rows: _vm.pageModel.table.items,
                        actions: _vm.pageModel.actions,
                        loading: _vm.pageModel.table.loading
                      }
                    },
                    [
                      _c("p", { attrs: { slot: "noData" }, slot: "noData" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                "expirationTrackedInventories.list.noResults"
                              )
                            ) +
                            "\n            "
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.hasPages && _vm.$mq !== "mobile"
                ? _c("base-pagination", {
                    staticClass: "list-page__footer",
                    attrs: {
                      slot: "pagination",
                      "current-page": _vm.pageModel.table.page,
                      results: _vm.pageModel.table.total,
                      "items-per-page": _vm.pageModel.table.pageSize,
                      "page-route": _vm.currentPageRoute
                    },
                    on: { paging: _vm.paging },
                    slot: "pagination"
                  })
                : _vm._e()
            ],
            1
          )
        : _c(
            "layout-secondary",
            [_c("failed-to-load", { on: { retry: _vm.reloadComponent } })],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }